// @flow
import React from 'react';
import type { PartnerSequence } from 'store/modules/partners';
import { fromNow } from 'lib/common';
import { Link } from 'react-router-dom';
import FakeLink from 'components/common/FakeLink';
import cx from 'classnames';
import './PartnerSequences.scss';

type PartnerSequenceItemProps = {
  sequence: PartnerSequence,
  username: string,
  active: boolean,
};

type Props = {
  sequences: ?(PartnerSequence[]),
  username: string,
  currentPartnerId: string,
};

const PartnerSequenceItem = ({ sequence, username, active }: PartnerSequenceItemProps) => {
  const { title, body, meta, url_slug, created_at } = sequence;
  const to = `/@${username}/partners/${url_slug}`;
  return (
    <FakeLink className={cx('PartnerSequenceItem', { active })} to={to}>
      <div className="date">{fromNow(created_at)}</div>
      <div className="title">
        <Link to={to}>{title}</Link>
      </div>
      <p>{(meta && meta.short_description) || body}</p>
    </FakeLink>
  );
};

const PartnerSequences = ({ sequences, username, currentPartnerId }: Props) => {
  if (!sequences || sequences.length === 0 || sequences.length === 1) return null;
  return (
    <div className="PartnerSequences">
      <div className="wrapper">
        <h3 className="title">다른 브랜드 둘러보기</h3>
        {sequences.map(s => (
          <PartnerSequenceItem
            key={s.id}
            sequence={s}
            username={username}
            active={s.id === currentPartnerId}
          />
        ))}
      </div>
    </div>
  );
};

export default PartnerSequences;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerSequences/PartnerSequences.js